<template>
  <div class="planos-container">
    <div class="back-button-top">
      <button class="back-link" @click="prevStep">Voltar</button>
    </div>
    <div class="logo-container">
      <img src="@/assets/img/logo.png" alt="LubConsulta" class="logo">
    </div>
    
    <div class="wizard narrow-wizard">
      <div class="step" :class="{ 'active': currentStep === 1 }">
        <div class="step-number">1</div>
        <div class="step-info">
          <div class="step-title">Confirme o plano</div>
          <div class="step-description">Você selecionou o Plano Basic.</div>
        </div>
      </div>
      <div class="step" :class="{ 'active': currentStep === 2 }">
        <div class="step-number">2</div>
        <div class="step-info">
          <div class="step-title">Pagamento</div>
          <div class="step-description">Dados de pagamento e tipo de cobrança.</div>
        </div>
      </div>
      <div class="step" :class="{ 'active': currentStep === 3 }">
        <div class="step-number">3</div>
        <div class="step-info">
          <div class="step-title">Assinatura</div>
          <div class="step-description">Seu Plano foi registrado com sucesso.</div>
        </div>
      </div>
    </div>

    <div class="step-content narrow-content">
      <!-- PASSO 1: CONFIRMAÇÃO DO PLANO BASIC -->
      <div v-if="currentStep === 1" class="step-1">
        <h2 class="narrow-title">Você escolheu o Plano Basic</h2>
        <p class="subtitle">Confira os benefícios incluídos no seu plano antes de prosseguir.</p>

        <div class="plans-container">
          <div class="plan-card">
            <div class="plan-header">
              <h2>Plano Basic</h2>
            </div>
            <div class="plan-pricing">
              <div class="monthly">
                <div class="price">89,90</div>
                <div class="period">ou mês</div>
              </div>
              <div class="yearly">
                <div class="price">838,80</div>
                <div class="period">por ano em até 12x</div>
              </div>
              <div class="savings2">Economize <strong>R$ 240,00</strong> no pagamento anual.</div>
            </div>
            <div class="plan-features">
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg>
                      Consulta de produtos pela placa do veículos
              </div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Consulta de veículos pelo modelo do veículo</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Download do manual do proprietário</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Ficha técnica de lubrificantes</div>
              <div class="feature" style="color: #6f7170;">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#6f7170" />
                        <path d="M15 9l-6 6m0 -6l6 6" />
                      </svg> Cadastro de clientes</div>
              <div class="feature" style="color: #6f7170;">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#6f7170" />
                        <path d="M15 9l-6 6m0 -6l6 6" />
                      </svg> Registro de serviço de troca de óleo</div>
              <div class="feature" style="color: #6f7170;">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#6f7170" />
                        <path d="M15 9l-6 6m0 -6l6 6" />
                      </svg> Lembrete automático via WhatsApp para a próxima troca de óleo do veículo</div>
            </div>
            <button class="select-button" @click="nextStep">CONTINUAR PARA PAGAMENTO</button>
          </div>
        </div>
      </div>

      <!-- PASSO 2: FORMULÁRIO E PAGAMENTO -->
      <div v-if="currentStep === 2" class="step-2">
        <h2 class="narrow-title">Escolha a forma de pagamento</h2>
        
        <div class="plan-card2" style="border: 1px solid #f4a954; border-radius: 8px; padding: 10px;">                  
          <div class="plan-sub" style="font-weight: bold; text-align: left;">PLANO SELECIONADO</div>
          <div class="plan-name" style="background-color: #ef8d1e; color: white; font-size: 24px; font-weight: bold; border-radius: 5px; padding: 8px; width: 250px; margin-bottom: 5px;">
            Plano Basic
          </div>
          <div class="plan-value" style="margin-bottom: 10px; padding: 10px;">
            <div class="plan-price" style="font-weight: bold; font-size: 20px; color:rgb(133, 131, 131);">
              R$ 89,90 mensal ou R$ 838,80 anual
            </div>
          </div>

          <!-- Cupom -->
          <!-- <div class="collapse-item">
            <div class="collapse-header" @click="toggleCoupon" style="cursor: pointer;">
              <IconCirclePercentageFilled :stroke="2" style="display: inline-block; vertical-align: middle; color: #3E8DDD; margin-right: 8px;" />  
              <strong>ADICIONAR CUPOM DE DESCONTO</strong>
              <span class="collapse-icon" :class="{ expanded: showCoupon }">▼</span>
            </div>
            <div v-if="showCoupon" class="collapse-content" style="margin-top: 5px;">
              <div class="coupon-input">
                <div class="form-group">
                  <input 
                    type="text" 
                    class="form-input" 
                    v-model="coupon.code" 
                    placeholder="CÓDIGO" 
                    @input="onCouponInput" 
                  >
                </div>
                <button class="btn btn-outline" @click="validateCoupon">Validar</button>
              </div>
            </div>
          </div> -->


          <div class="collapse-item" style="margin: 5px 0;">
            <div class="collapse-header" @click="togglePlanDetails" style="cursor: pointer;">
              <IconArrowBigRightFilled :stroke="2" style="display: inline-block; vertical-align: middle; color: #3E8DDD; margin-right: 8px;" />   
              <strong>Ver detalhes do plano</strong>
              <span class="collapse-icon" :class="{ expanded: showPlanDetails }">▼</span>
            </div>
            <div v-if="showPlanDetails" class="collapse-content" style="margin-top: 5px;">
              <div>
                  <p><strong>O que o plano oferece:</strong></p>
                  <ul style="margin-left: 20px; margin-top: 10px;">
                      <li>Consulta de produtos pela placa do veículo</li>
                      <li>Consulta de veículos pelo modelo do veículo</li>
                      <li>Download do manual do propietário</li>
                      <li>Ficha técnica de lubrificantes</li>
                  </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="form-section">
          <h2 class="form-title">Dados do Cliente</h2>
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">CNPJ <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="personalInfo.document" placeholder="00.000.000/0000-00" @input="onCnpjInput" @blur="fetchAndPopulateCustomerData">
            </div>
            <div class="form-group">
              <label class="form-label">Nome completo <span class="required">*</span></label>
              <!-- CORREÇÃO AQUI: Removido class duplicado e usado o :class condicional -->
              <input type="text" class="form-input" :class="{ 'disabled-field': fieldStates.fullName }" v-model="personalInfo.fullName" :disabled="fieldStates.fullName">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Telefone <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="personalInfo.phone" placeholder="(99) 9 9999-9999" @input="onPhoneInput">
            </div>
            <div class="form-group">
              <label class="form-label">E-mail <span class="required">*</span></label>
              <input type="email" class="form-input" v-model="personalInfo.email" placeholder="seu@email.com">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Endereço <span class="required">*</span></label>
              <input type="text" class="form-input" :class="{ 'disabled-field': fieldStates.street }" v-model="billingAddress.street" :disabled="fieldStates.street">
            </div>
            <div class="form-group">
              <label class="form-label">CEP <span class="required">*</span></label>
              <input type="text" class="form-input" :class="{ 'disabled-field': fieldStates.zipCode }" v-model="billingAddress.zipCode" :disabled="fieldStates.zipCode">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Número <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.number">
            </div>
            <div class="form-group">
              <label class="form-label">Bairro</label>
              <input type="text" class="form-input" :class="{ 'disabled-field': fieldStates.bairro }" v-model="billingAddress.bairro" :disabled="fieldStates.bairro">
            </div>
            <div class="form-group">
              <label class="form-label">Cidade <span class="required">*</span></label>
              <input type="text" class="form-input" :class="{ 'disabled-field': fieldStates.city }" v-model="billingAddress.city" :disabled="fieldStates.city">
            </div>
          </div>
        </div>

        <div class="form-section">
          <h2 class="form-title">Forma de pagamento</h2>
          <div class="payment-methods">
            <div class="payment-method" :class="{ active: paymentMethod === 'creditCard' }" @click="paymentMethod = 'creditCard'">
              <strong>Cartão</strong> 
              <IconCreditCardFilled />
            </div>
            <div class="payment-method" :class="{ active: paymentMethod === 'boleto' }" @click="paymentMethod = 'boleto'; valorSelecionado = ''">
              <strong>Boleto</strong> 
              <IconBarcode />
            </div>
            <div class="payment-method" :class="{ active: paymentMethod === 'pix' }" @click="paymentMethod = 'pix'; valorSelecionado = ''">
              <strong>Pix</strong> 
              <IconQrcode />
            </div>
          </div>

          <!-- Seleção de Valores BASIC -->
          <div v-if="paymentMethod === 'creditCard'">
            <div class="form-group">
              <label class="form-label">Valor e Parcelamento <span class="required">*</span></label>
              <select v-model="valorSelecionado" class="form-input" @change="handlePaymentOptionChange">
                <option value="">Selecione o plano...</option>
                <option value="basic_monthly">R$ 89,90 mensal (Assinatura)</option>
                <option value="basic_yearly">R$ 838,80 anual à vista</option>
                <option value="basic_installment_2">Em 2x de R$ 419,40 — Total: R$ 838,80</option>
                <option value="basic_installment_3">Em 3x de R$ 279,60 — Total: R$ 838,80</option>
                <option value="basic_installment_6">Em 6x de R$ 139,80 — Total: R$ 838,80</option>
                <option value="basic_installment_10">Em 10x de R$ 83,88 — Total: R$ 838,80</option>
                <option value="basic_installment_12">Em 12x de R$ 69,90 — Total: R$ 838,80</option>
              </select>
            </div>
            
            <div class="form-row" style="margin-top:15px">
                <div class="form-group">
                    <label class="form-label">Número do cartão <span class="required">*</span></label>
                    <input type="text" class="form-input" v-model="creditCard.number" placeholder="0000 0000 0000 0000" @input="onCardNumberInput">
                </div>
                <div class="form-group">
                    <label class="form-label">Nome impresso no cartão <span class="required">*</span></label>
                    <input type="text" class="form-input" v-model="creditCard.holderName" placeholder="NOME COMO ESTÁ NO CARTÃO">
                </div>
            </div>

            <!-- PERGUNTA: MESMO TITULAR? -->
            <div class="holder-selection" style="margin: 15px 0; text-align: left;">
              <label class="form-label">O titular deste cartão é o mesmo cliente (CNPJ) informado acima?</label>
              <div style="display: flex; gap: 20px; margin-top: 5px;">
                <label style="cursor: pointer; display: flex; align-items: center; gap: 8px;">
                  <input type="radio" :value="true" v-model="isHolderSameAsCustomer"> Sim
                </label>
                <label style="cursor: pointer; display: flex; align-items: center; gap: 8px;">
                  <input type="radio" :value="false" v-model="isHolderSameAsCustomer"> Não
                </label>
              </div>
            </div>

            <!-- BLOCO CONDICIONAL (SÓ APARECE SE FOR "NÃO") -->
            <transition name="fade-slide">
              <div v-if="!isHolderSameAsCustomer" class="holder-info-card">
                <p style="font-size: 13px; color: #888; margin-bottom: 15px; font-weight: bold;">
                  Dados de faturamento do Titular do Cartão:
                </p>
                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label">CPF/CNPJ do titular <span class="required">*</span></label>
                    <input type="text" class="form-input holder-field-bg" v-model="creditCard.holderDocument" @input="onHolderDocumentInput" placeholder="000.000.000-00">
                  </div>
                  <div class="form-group">
                      <label class="form-label">CEP de fatura <span class="required">*</span></label>
                      <input type="text" class="form-input holder-field-bg" v-model="creditCard.billingZipCode" placeholder="00000-000">
                  </div>
                  <div class="form-group" style="flex: 0 0 100px;">
                      <label class="form-label">Nº <span class="required">*</span></label>
                      <input type="text" class="form-input holder-field-bg" v-model="creditCard.billingNumber">
                  </div>
                </div>
              </div>
            </transition>

            <div class="form-row">
                <div class="form-group" style="flex: 0 0 150px;">
                  <label class="form-label">Validade <span class="required">*</span></label>
                  <input type="text" class="form-input" v-model="creditCard.expiryDate" placeholder="MM/AA">
                </div>
                <div class="form-group" style="flex: 0 0 100px;">
                  <label class="form-label">CVV <span class="required">*</span></label>
                  <input type="text" class="form-input" v-model="creditCard.cvv" placeholder="000">
                </div>
            </div>

          </div>

          <div v-if="paymentMethod === 'pix' || paymentMethod === 'boleto'">
            <div class="form-group">
              <label class="form-label">Modalidade <span class="required">*</span></label>
              <select v-model="valorSelecionado" class="form-input" @change="handlePaymentOptionChange">
                <option value="">Selecione...</option>
                <option :value="'basic_' + paymentMethod + '_monthly'">R$ 89,90 mensal (Promocional)</option>
                <option :value="'basic_' + paymentMethod + '_yearly'">R$ 838,80 anual (Desconto)</option>
              </select>
            </div>
            
            <div v-if="paymentMethod === 'pix' && showPixDetails" style="text-align: center; margin-top: 20px;">
              <canvas id="pix-qr"></canvas>
              <p>Escaneie o código acima</p>
              <button class="btn btn-secondary" @click="copyPixCode">Copiar código Pix</button>
            </div>

            <div v-if="paymentMethod === 'boleto' && showBoleto" style="text-align: center; margin-top: 20px;">
              <p>Boleto gerado com sucesso!</p>
              <a :href="dados.linkFatura" target="_blank" class="btn btn-primary">Visualizar Boleto</a>
            </div>
          </div>


          <div class="collapse-item" style="border: 1px dashed #E4A64E; border-radius: 25px; margin-top: 20px; padding: 10px 20px;">
            <div class="collapse-header" @click="toggleCoupon" style="cursor: pointer;">
              <IconCirclePercentageFilled :stroke="2" style="display: inline-block; vertical-align: middle; color: #3E8DDD; margin-right: 8px;" />  
              <strong>POSSUI CUPOM DE DESCONTO?</strong>
              <span class="collapse-icon" :class="{ expanded: showCoupon }">▼</span>
            </div>
            <div v-if="showCoupon" class="collapse-content" style="margin-top: 10px;">
              <div class="coupon-input" style="display: flex; gap: 10px;">
                <div class="form-group" style="margin-bottom: 0;">
                  <input type="text" class="form-input" v-model="coupon.code" placeholder="DIGITE O CÓDIGO" @input="onCouponInput">
                </div>
                <button class="btn btn-outline" @click="validateCoupon">Aplicar</button>
              </div>
              <p v-if="coupon.applied" style="color: #53b42f; font-size: 12px; margin-top: 5px; font-weight: bold;">✓ Desconto de R$ {{ coupon.discountValue.toFixed(2) }} aplicado!</p>
            </div>
          </div>
          
          <div v-if="valorSelecionado" class="charge-summary" style="margin-top: 20px; text-align: center; background: #fff5e6; padding: 15px; border-radius: 25px;">
            <label class="form-label" style="text-align:center;">Resumo da Cobrança:</label>
            
            <!-- VALOR TOTAL EM DESTAQUE -->
            <div style="font-weight: bold; font-size: 1.6em; color: #ef8d1e;">
              R$ {{ valorFinalFormatado }}
              <span style="font-size: 0.5em; color: #666;"> (Total)</span>
            </div>

            <!-- DETALHE DA PARCELA (SÓ APARECE SE TIVER MAIS DE 1 PARCELA) -->
            <div v-if="valorParcelaAtualizada" style="font-size: 1.1em; color: #666; margin-top: 5px;">
              Ou em {{ paymentOptionConfig.installments }}x de <strong>R$ {{ valorParcelaAtualizada }}</strong> sem juros
            </div>
          </div>
        </div>

        <div class="navigation-buttons">
          <button class="btn btn-secondary" @click="prevStep">Voltar</button>
          <button v-if="paymentMethod === 'creditCard' && !isProcessing" class="btn btn-primary" @click="showConfirmationModal">Finalizar Pagamento</button>
          <div v-if="isProcessing" class="btn btn-primary disabled">Processando...</div>
        </div>
      </div>

      <!-- PASSO 3: SUCESSO -->
      <div v-if="currentStep === 3" class="step-3" style="text-align: center; padding: 40px;">
        <div style="font-size: 60px; color: #53b42f; margin-bottom: 20px;">✓</div>
        <h2>Assinatura Basic Concluída!</h2>
        <p>Seus dados de acesso foram enviados para: <strong>{{ personalInfo.email }}</strong></p>
        <div class="navigation-buttons" style="justify-content: center;">
          <a href="https://app.lubconsulta.com.br" class="btn btn-primary">Acessar Plataforma Agora</a>
        </div>
      </div>
    </div>

    <footer class="site-footer">@ lubconsuta.com.br</footer>

    <!-- Modais (Mesma lógica do original) -->
    <div v-if="showModal" class="modal-overlay">
        <div class="modal-content">
            <h3 class="modal-title">{{ modalTitle }}</h3>
            <p class="modal-message">{{ modalMessage }}</p>
            <button class="modal-close-btn" @click="closeModal">Fechar</button>
        </div>
    </div>

    <div v-if="showPaymentConfirmationModal" class="modal-overlay">
        <div class="modal-content">
            <h3 class="modal-title">Confirmação de Pagamento</h3>
            <div style="text-align: left; background: #f9f9f9; padding: 15px; border-radius: 8px;">
                <p><strong>Plano:</strong> Plano Basic</p>
                <p><strong>Modalidade:</strong> {{ selectedOptionDescription }}</p>
                <p><strong>Valor:</strong> R$ {{ valorFinalFormatado }}</p>
            </div>
            <div class="modal-actions" style="margin-top: 20px; display: flex; gap: 10px;">
                <button class="btn btn-secondary" style="flex: 1;" @click="showPaymentConfirmationModal = false">Corrigir</button>
                <button class="btn btn-primary" style="flex: 1;" @click="confirmPayment">Confirmar e Pagar</button>
            </div>
        </div>
    </div>

    <LoadingSpinner :show="showLoadingSpinner" :message="loadingMessage" />
  </div>
</template>

<script>
import QRCode from 'qrcode'
import apiClient from '@/services/api.js'; 
import LoadingSpinner from '@/modules/planos/LoadingSpinner.vue';

export default {
  name: 'PlanoBasic',
  components: { LoadingSpinner },
  data() {
    return {
      currentStep: 1,
      selectedPlan: 'basic',
      isProcessing: false,
      showLoadingSpinner: false,
      loadingMessage: 'Processando...',
      paymentMethod: 'creditCard',
      valorSelecionado: '',
      showCoupon: false,
      showPlanDetails: false,
      showPixDetails: false,
      showBoleto: false,
      pixCode: '',
      isHolderSameAsCustomer: true, 
      clienteId: null,
      personalInfo: { fullName: '', document: '', phone: '', email: '' },
      billingAddress: { street: '', number: '', bairro: '', zipCode: '', city: '', state: '' },
      creditCard: {
                    number: '',
                    holderName: '',
                    holderDocument: '',
                    expiryDate: '',
                    cvv: '',
                    billingZipCode: '', // Adicione este campo
                    billingNumber: ''   // Adicione este campo
                  },
      fieldStates: { fullName: true, street: true, zipCode: true, city: true, bairro: true },
      coupon: { code: '', applied: false, discountValue: 0 },
      dados: { linkFatura: '' },
      showModal: false,
      modalTitle: '',
      modalMessage: '',
      showPaymentConfirmationModal: false,
      paymentMonitorInterval: null
    }
  },
  computed: {
    // Localize o paymentOptionConfig e substitua por este:
  paymentOptionConfig() {
    const options = {
      // MENSAL
      basic_monthly: { value: 89.90, description: 'Plano Basic Mensal', annual: false, installments: 1 },
      
      // ANUAIS (O valor base aqui deve ser sempre o TOTAL de 838,80 para o cupom incidir sobre ele)
      basic_yearly: { value: 838.80, description: 'Plano Basic Anual à Vista', annual: true, installments: 1 },
      basic_installment_2: { value: 838.80, description: 'Basic Anual em 2x', annual: true, installments: 2 },
      basic_installment_3: { value: 838.80, description: 'Basic Anual em 3x', annual: true, installments: 3 },
      basic_installment_6: { value: 838.80, description: 'Basic Anual em 6x', annual: true, installments: 6 },
      basic_installment_10: { value: 838.80, description: 'Basic Anual em 10x', annual: true, installments: 10 },
      basic_installment_12: { value: 838.80, description: 'Basic Anual em 12x', annual: true, installments: 12 },
      
      // PIX/BOLETO
      basic_pix_monthly: { value: 89.90, description: 'Basic Mensal (Pix)', annual: false, installments: 1 },
      basic_pix_yearly: { value: 838.80, description: 'Basic Anual (Pix)', annual: true, installments: 1 },
      basic_boleto_monthly: { value: 89.90, description: 'Basic Mensal (Boleto)', annual: false, installments: 1 },
      basic_boleto_yearly: { value: 838.80, description: 'Basic Anual (Boleto)', annual: true, installments: 1 }
    };
    return options[this.valorSelecionado] || null;
  },
    // FORMA NOVA (ARREDONDADA)
    valorFinalCalculado() {
      if (!this.paymentOptionConfig) return 0;
      const valorBaseTotal = this.paymentOptionConfig.value;
      
      let resultado = valorBaseTotal;
      if (this.coupon.applied) {
        resultado = Math.max(0, valorBaseTotal - this.coupon.discountValue);
      }
      
      // CORREÇÃO: Garante 2 casas decimais antes de enviar ao backend
      return parseFloat(resultado.toFixed(2));
    },

    // NOVA COMPUTED para mostrar o valor da parcela no resumo
    valorParcelaAtualizada() {
      if (!this.paymentOptionConfig || this.paymentOptionConfig.installments <= 1) return null;
      const valorComDesconto = this.valorFinalCalculado; // Esse já é o total - cupom
      return (valorComDesconto / this.paymentOptionConfig.installments).toFixed(2).replace('.', ',');
    },
    valorFinalFormatado() {
      return this.valorFinalCalculado.toFixed(2).replace('.', ',');
    },
    selectedOptionDescription() {
      return this.paymentOptionConfig?.description || '';
    }
  },
  methods: {
    onCouponInput() {
      this.coupon.code = this.coupon.code.toUpperCase();
      this.coupon.applied = false; // Reseta o valor enquanto ele digita novo cupom

      // Se o usuário apagar o cupom, o valor volta ao original automaticamente
      if (this.coupon.code.length >= 4) {
        this.validateCouponAutomatic();
      }
    },

    async validateCouponAutomatic() {
      try {
        const res = await apiClient.get(`/cupons/busca-nome?nome=${this.coupon.code}`);
        if (res.data && res.data.length > 0) {
          const cupom = res.data[0];
          const planoDB = cupom.plano.toUpperCase();
          
          // Verifica se o cupom serve para o plano BASIC
          if (planoDB.includes('BASIC')) {
            this.coupon.applied = true;
            this.coupon.discountValue = parseFloat(cupom.valor);
          }
        }
      } catch (e) {
        this.coupon.applied = false;
      }
    },
    onCnpjInput(e) {
      let val = e.target.value.replace(/\D/g, "").slice(0, 14);
      val = val.replace(/^(\d{2})(\d)/, "$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
      this.personalInfo.document = val;
    },
    onPhoneInput(e) {
      let val = e.target.value.replace(/\D/g, "").slice(0, 11);
      if (val.length > 2 && val.length <= 6) val = `(${val.slice(0, 2)}) ${val.slice(2)}`;
      else if (val.length > 6) val = `(${val.slice(0, 2)}) ${val.slice(2, 3)} ${val.slice(3, 7)}-${val.slice(7)}`;
      this.personalInfo.phone = val;
    },
    onCardNumberInput(e) {
      let digits = e.target.value.replace(/\D/g, '').slice(0, 16);
      this.creditCard.number = digits.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
    },
    onHolderDocumentInput(e) {
      let val = e.target.value.replace(/\D/g, "").slice(0, 14);
      if (val.length <= 11) val = val.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      else val = val.replace(/^(\d{2})(\d)/, "$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
      this.creditCard.holderDocument = val;
    },
    async fetchAndPopulateCustomerData() {
      const doc = this.personalInfo.document.replace(/\D/g, '');
      if (doc.length !== 14) return;
      this.showLoadingSpinner = true;
      try {
        const response = await fetch(`https://publica.cnpj.ws/cnpj/${doc}`);
        const data = await response.json();
        const est = data.estabelecimento;
        this.personalInfo.fullName = data.razao_social;
        this.billingAddress.street = `${est.tipo_logradouro || ''} ${est.logradouro || ''}`.trim();
        this.billingAddress.number = est.numero || 'S/N';
        this.billingAddress.zipCode = est.cep;
        this.billingAddress.city = est.cidade.nome;
        this.billingAddress.bairro = est.bairro || '';
      } catch (e) { console.error(e); }
      finally { this.showLoadingSpinner = false; }
    },
    async validateCoupon() {
      const code = this.coupon.code.trim();
      if (!code) return alert("Digite o código do cupom.");

      this.showLoadingSpinner = true;
      try {
        const res = await apiClient.get(`/cupons/busca-nome?nome=${code}`);
        if (!res.data || res.data.length === 0) throw new Error("Cupom não encontrado.");
        
        const cupom = res.data[0];
        const planoDB = cupom.plano.toUpperCase();

        // Validação básica: O cupom deve ser para o plano BASIC
        if (!planoDB.includes('BASIC')) {
            throw new Error("Este cupom não é válido para o Plano Basic.");
        }

        // Se já houver um plano selecionado, valida a periodicidade (Mensal/Anual)
        if (this.valorSelecionado) {
            const isAnual = this.paymentOptionConfig.annual;
            if (!planoDB.includes(isAnual ? 'ANUAL' : 'MENSAL')) {
                throw new Error(`Este cupom é válido apenas para a modalidade ${planoDB.includes('ANUAL') ? 'ANUAL' : 'MENSAL'}.`);
            }
        }

        this.coupon.applied = true;
        this.coupon.discountValue = parseFloat(cupom.valor);
        alert(`Cupom validado! Desconto de R$ ${this.coupon.discountValue.toFixed(2)} aplicado ao total.`);
      } catch (e) {
        this.coupon.applied = false;
        alert(e.message || "Erro ao validar cupom.");
      } finally {
        this.showLoadingSpinner = false;
      }
    },
    handlePaymentOptionChange() {
      // this.coupon.applied = false;
      if (!this.personalInfo.phone || !this.personalInfo.email) {
          alert("Preencha e-mail e telefone antes.");
          this.valorSelecionado = '';
          return;
      }
      if (this.paymentMethod === 'pix') this.handleValorPixChange();
      else if (this.paymentMethod === 'boleto') this.handleValorBoletoChange();
    },
    async handleValorPixChange() {
        this.showLoadingSpinner = true;
        try {
            const payload = {
                personalInfo: this.personalInfo,
                billingAddress: this.billingAddress,
                billingType: "PIX",
                value: this.valorFinalCalculado,
                paymentOptionId: this.valorSelecionado,
                selectedPlanName: 'basic'
            };
            const res = await apiClient.post('/criar-assinatura', payload);
            this.clienteId = res.data.customer;
            this.pixCode = res.data.paymentDetails.pixData.payload;
            this.showPixDetails = true;
            this.$nextTick(() => { 
                const canvas = document.getElementById('pix-qr');
                QRCode.toCanvas(canvas, this.pixCode, { width: 200 });
            });
            this.monitorPaymentStatus();
        } catch (e) { alert("Erro ao gerar Pix"); }
        finally { this.showLoadingSpinner = false; }
    },
    async handleValorBoletoChange() {
        this.showLoadingSpinner = true;
        try {
            const payload = {
                personalInfo: this.personalInfo,
                billingAddress: this.billingAddress,
                billingType: "BOLETO",
                value: this.valorFinalCalculado,
                paymentOptionId: this.valorSelecionado,
                selectedPlanName: 'basic'
            };
            const res = await apiClient.post('/criar-assinatura', payload);
            this.clienteId = res.data.customer;
            this.dados.linkFatura = res.data.paymentDetails.invoiceUrl;
            this.showBoleto = true;
            this.monitorPaymentStatus();
        } catch (e) { alert("Erro ao gerar boleto"); }
        finally { this.showLoadingSpinner = false; }
    },
    async confirmPayment() {
        // 1. Validação de segurança para o Asaas (Parcela mínima R$ 5,00)
        if (this.paymentOptionConfig.installments > 1) {
            const valorParcela = this.valorFinalCalculado / this.paymentOptionConfig.installments;
            if (valorParcela < 5.00) {
                this.modalTitle = "Ajuste o Parcelamento";
                this.modalMessage = `Com este desconto, as parcelas ficariam em R$ ${valorParcela.toFixed(2).replace('.', ',')}. O valor mínimo por parcela permitido pelo gateway é R$ 5,00. Por favor, escolha menos parcelas.`;
                this.showModal = true;
                return;
            }
        }

        this.showPaymentConfirmationModal = false;
        this.isProcessing = true;
        this.showLoadingSpinner = true;
        
        // MENSAGEM 1: Inicial
        this.loadingMessage = "Validando dados junto ao gateway Asaas...";

        // Cronômetro para mudar a mensagem após 3 segundos
        const messageTimer = setTimeout(() => {
            if (this.isProcessing) {
                this.loadingMessage = "Validando junto à operadora do cartão...";
            }
        }, 3000);

        try {
            const [m, a] = this.creditCard.expiryDate.split('/');
            
            // Montagem do Titular (Antifraude)
            const holderInfo = {
                name: this.creditCard.holderName,
                email: this.personalInfo.email,
                phone: this.personalInfo.phone.replace(/\D/g, ''),
                cpfCnpj: this.isHolderSameAsCustomer 
                    ? this.personalInfo.document.replace(/\D/g, '') 
                    : this.creditCard.holderDocument.replace(/\D/g, ''),
                postalCode: this.isHolderSameAsCustomer 
                    ? this.billingAddress.zipCode.replace(/\D/g, '') 
                    : this.creditCard.billingZipCode.replace(/\D/g, ''),
                addressNumber: this.isHolderSameAsCustomer 
                    ? this.billingAddress.number 
                    : this.creditCard.billingNumber
            };

            const payload = {
                personalInfo: this.personalInfo,
                billingAddress: this.billingAddress,
                billingType: "CREDIT_CARD",
                value: this.valorFinalCalculado, // Valor já arredondado pela computed
                paymentOptionId: this.valorSelecionado,
                selectedPlanName: this.selectedPlan,
                creditCard: {
                    holderName: this.creditCard.holderName,
                    number: this.creditCard.number.replace(/\D/g, ''),
                    expiryMonth: m,
                    expiryYear: "20" + a,
                    ccv: this.creditCard.cvv // Backend agora aceita ccv ou cvv
                },
                creditCardHolderInfo: holderInfo 
            };

            await apiClient.post('/criar-assinatura-credcard', payload);
            
            clearTimeout(messageTimer);
            this.currentStep = 3;

        } catch (e) {
            clearTimeout(messageTimer);
            this.modalTitle = "Erro no Pagamento";
            // O backend agora envia a descrição amigável do erro
            this.modalMessage = e.response?.data?.details || "Falha ao processar o cartão.";
            this.showModal = true;
        } finally {
            this.isProcessing = false;
            this.showLoadingSpinner = false;
            this.loadingMessage = "Processando...";
        }
    },
    monitorPaymentStatus() {
      if (this.paymentMonitorInterval) clearInterval(this.paymentMonitorInterval);
      this.paymentMonitorInterval = setInterval(async () => {
        try {
          const res = await apiClient.get(`/listarCobranca?customer=${this.clienteId}`);
          if (['RECEIVED', 'CONFIRMED'].includes(res.data.status)) {
            clearInterval(this.paymentMonitorInterval);
            this.currentStep = 3;
          }
        } catch (e) { console.log("Aguardando..."); }
      }, 4000);
    },
    copyPixCode() { navigator.clipboard.writeText(this.pixCode); alert('Copiado!'); },
    showConfirmationModal() { this.showPaymentConfirmationModal = true; },
    closeModal() { this.showModal = false; },
    nextStep() { this.currentStep++; },
    prevStep() { if (this.currentStep > 1) this.currentStep--; },
    toggleCoupon() { this.showCoupon = !this.showCoupon; },
    togglePlanDetails() { this.showPlanDetails = !this.showPlanDetails; }
  },
  watch: {
    'creditCard.expiryDate'(val) {
        let cleaned = val.replace(/\D/g, '').slice(0, 4);
        if (cleaned.length > 2) cleaned = cleaned.slice(0, 2) + '/' + cleaned.slice(2);
        this.creditCard.expiryDate = cleaned;
    }
  }
}
</script>



<style scoped>

.holder-field-bg {
  background-color: #fdfaf3 !important; 
  border: 1px solid #f1e0c5 !important;
}

.holder-info-card {
  background-color: #fdfdfd;
  border: 1px solid #eee;
  border-radius: 20px; /* Seguindo o padrão arredondado do seu layout */
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: inset 0 0 8px rgba(0,0,0,0.02);
}

/* Animação para o card abrir suavemente */
.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.4s ease;
  max-height: 300px;
  overflow: hidden;
}
.fade-slide-enter-from, .fade-slide-leave-to {
  opacity: 0;
  max-height: 0;
  transform: translateY(-10px);
}

.payment-confirmation-modal {
  max-width: 500px;
  text-align: left;
}

.payment-details {
  margin: 20px 0;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border-left: 4px solid #3E8DDD;
}

.detail-item {
  margin-bottom: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.detail-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.detail-item strong {
  color: #333;
  min-width: 150px;
  display: inline-block;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}
</style>



<style scoped>

.input-invalid {
  border-color: #e74c3c !important; /* Borda vermelha */
  background-color: rgba(231, 76, 60, 0.08) !important; /* Fundo vermelho bem fraquinho */
}

/* Opcional: para o foco, manter o vermelho */
.input-invalid:focus {
  border-color: #c0392b !important;
  box-shadow: 0 0 0 0.2rem rgba(231, 76, 60, 0.25) !important;
}

/* Garanta que o estilo padrão do input ainda seja aplicado quando válido */
.form-input {
  /* Seus estilos padrão aqui */
  border: 1px solid #ccc; /* Exemplo de borda padrão */
  background-color: #fff; /* Exemplo de fundo padrão */
  padding: 10px;
  border-radius: 4px;
  width: 100%;
}

.boleto-container {
  max-width: 900px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  background-color: white;
  color: black;
}

.linha-digitavel {
  border: 2px solid black;
  padding: 8px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 8px;
}

.boleto-box {
  border: 2px solid black;
}

.linha {
  display: flex;
  border-bottom: 1px solid black;
}

.linha:last-child {
  border-bottom: none;
}

.col {
  border-right: 1px solid black;
  padding: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.col:last-child {
  border-right: none;
}

.col.grande {
  flex: 3;
}

.col.pequeno {
  flex: 1.2;
}

.col.logo {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.col.numero {
  flex: 0.5;
  font-weight: bold;
  font-size: 18px;
  align-items: center;
}

.col.linha-digitavel-right {
  flex: 2;
  font-weight: bold;
  font-size: 14px;
  align-items: center;
}

.col.qrcode {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.col.codigo-barras {
  flex: 3;
  justify-content: center;
  align-items: center;
}

.codigo-barras-texto {
  font-family: 'Libre Barcode 128', monospace;
  font-size: 40px;
}

.rotulo {
  font-size: 10px;
  color: gray;
}

a {
  color: blue;
  text-decoration: underline;
  font-size: 10px;
}


.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 25px 30px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  width: 90%;
  max-width: 450px;
  text-align: center;
}

.modal-title {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.5rem;
  color: #333;
}

.modal-message {
  margin-bottom: 25px;
  font-size: 1rem;
  color: #555;
  white-space: pre-wrap; /* Para quebras de linha em mensagens de erro */
}

.modal-close-btn {
  background-color: #3E8DDD;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: background-color 0.2s;
}

.modal-close-btn:hover {
  background-color: #3477bb;
}

/* NOVO: Estilo para botão desabilitado */
button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}



@media print {
  body {
    visibility: hidden;
  }

  .boleto-container {
    visibility: visible;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}

@keyframes toast-fadein {
  from { opacity: 0; transform: translate(-50%, -100%); }
  to { opacity: 1; transform: translate(-50%, -50%); }
}

@keyframes toast-fadeout {
  from { opacity: 1; transform: translate(-50%, -50%); }
  to { opacity: 0; transform: translate(-50%, -100%); }
}

/* Adicione ao seu arquivo CSS */
.form-input-size-4 {
  flex: 0 0 calc(33.333% - 10px) !important;
  max-width: calc(33.333% - 10px) !important;
}

.form-input-size-8 {
  flex: 0 0 calc(66.666% - 10px) !important;
  max-width: calc(66.666% - 10px) !important;
}

.disabled-field {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.unlock-btn {
  margin-top: 15px;
  padding: 8px 15px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.unlock-btn:hover {
  background-color: #e9ecef;
}

.icone-svg {
 flex-shrink: 0; /* evita encolher */
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.narrow-wizard {
  max-width: 800px;
  margin: 0 auto;
  padding: 0px;
}

.narrow-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 15px;
}

.narrow-title {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px;
  text-align: center;
}

.wizard {
  display: flex;
  justify-content: space-between;
}

.step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.step-info {
  max-width: 200px;
}

.planos-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  position: relative;
  min-height: 100vh;
  padding-bottom: 60px;
  background-color: #fff; 
}

.logo-container {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  max-width: 350px;
  height: auto;
}

.wizard {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  position: relative;
}

.wizard::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #e0e0e0;
  z-index: 1;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  flex: 1;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  font-weight: bold;
}

.step.active .step-number {
  background-color: #E4A64E;
}

.step-info {
  text-align: center;
  padding: 0 10px;
}

.step-title {
  font-weight: bold;
  margin-bottom: 5px;
}

.step-description {
  font-size: 0.9em;
  color: #666;
}

.step-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.step-content h2 {
  color: #333;
  margin-bottom: 10px;
}

.subtitle {
  color: #666;
  margin-bottom: 30px;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px;
}

.plans-container {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
}

.plan-card {
 flex: 1;
  min-width: 300px;
  max-width: 50%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 600px;
}

.plan-card2 {
  flex: 1;
  min-width: 300px;
  max-width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
}

.plan-card:hover {
  transform: translateY(-5px);
}

.plan-card.plus {
  border-top: 4px solid #E4A64E;
}

.plan-header {
  background-color: #E4A64E;
  color: white;
  padding: 20px;
  text-align: center;
}

.plan-sub {
  background-color: #ffffff;
  color: #000000;
  padding: 10px;
}

.plan-header h2 {
  margin: 0;
  color: #ffffff;
}

.plan-pricing {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
}

.monthly, .yearly {
  margin-bottom: 15px;
}

.price {
  font-size: 1.8em;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  line-height: 1;
}

.price::before {
  content: "R$";
  font-size: 0.6em;
  align-self: flex-start;
  margin-right: 4px;
  margin-top: 0.2em;
}

.period {
  color: #666;
  font-size: 0.9em;
}

.savings {
  background-color: #d9d8d6;
  border-radius: 6px;
  padding: 8px 12px;
  display: inline-block;
  margin-top: 10px;
  color: #000000;
  font-size: 0.9em;
}

.savings2 {
  background-color: #53b42f;
  border-radius: 6px;
  padding: 8px 12px;
  display: inline-block;
  margin-top: 10px;
  color: #ffffff;
  font-size: 0.9em;
}

.plan-features {
  padding: 20px;
  flex-grow: 1;
  gap: 12px; 
}

.feature {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.feature i {
  color: #E4A64E;
  margin-right: 10px;
  font-size: 1.2em;
  vertical-align: middle;
}

.feature .menu-icon {
  color: #E4A64E;
  margin-right: 10px;
  width: 1.2em;
  height: 1.2em;
  stroke-width: 1.5;
}

.feature input[type="checkbox"] {
  margin-right: 10px;
}

.select-button {
  display: block;
  width: 100%;
  padding: 15px;
  background-color: #E4A64E;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.select-button:hover {
  background-color: #E4A64E;
}

.navigation-buttons {
  display: flex;
  width: 100%;
  gap: 10px; 
  justify-content: space-between;
  margin-top: 30px;
}

.back-button, .next-button {
  padding: 10px 20px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
}

.back-button {
  padding: 15px;
  background-color: #f1f1f1;
  color: #333;
}

.nav-button {
  flex: 1; /* Isso fará com que cada botão ocupe igual espaço */
  min-width: 0; /* Importante para evitar problemas de overflow */
  padding: 2px; /* Ajuste o padding conforme necessário */
  text-align: center;
}

.next-button {
  background-color: #E4A64E;
  color: white;
}

/* Estilos para o botão de voltar no topo */
.back-button-top {
  position: absolute;
  top: 20px;
  right: 20px;
}

.back-link {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #E4A64E;
  text-decoration: none;
  font-weight: bold;
  padding: 8px 12px;
  border: 1px solid #E4A64E;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.back-link:hover {
  background-color: #E4A64E;
  color: white;
}

/* Estilos para o footer */
.site-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  text-align: left;
  color: #666;
  font-size: 0.9em;
  border-top: 1px solid #e0e0e0;
}

/* Estilos para o botão do WhatsApp */
.whatsapp-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background-color: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.whatsapp-button i {
  color: white;
  font-size: 30px;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* Estilos para o chat do WhatsApp */
.whatsapp-chat {
  position: fixed;
  bottom: 100px;
  right: 30px;
  width: 300px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  overflow: hidden;
}

.chat-header {
  background-color: #075E54;
  color: white;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-header h3 {
  margin: 0;
  font-size: 16px;
}

.close-chat {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 18px;
}

.chat-body {
  padding: 15px;
}

.chat-body textarea {
  width: 100%;
  height: 100px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
  resize: none;
}

.chat-footer {
  padding: 10px 15px;
  text-align: right;
  background-color: #f5f5f5;
}

.send-button {
  background-color: #25D366;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
} 

.send-button:hover {
  background-color: #128C7E;
}

.plan-name {
  background-color: #E4A64E;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  display: inline-block;
  font-size: 14px;
  margin-bottom: 15px;
}

.collapse-item {
  border-bottom: 1px solid #eee;
  padding: 15px 0;
}

.collapse-item:last-child {
  border-bottom: none;
}

.collapse-header {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
}

.collapse-icon {
  margin-left: 10px;
  transition: transform 0.3s;
}

.collapse-icon.expanded {
  transform: rotate(180deg);
}

.collapse-content {
  margin-top: 15px;
  padding-left: 20px;
}


.form-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
}

.form-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: left;
  width: 100%;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;
}

.form-group {
  flex: 1 1 100%;
  min-width: 0;
}

.charge-summary {
  display: block;
  text-align: center;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
}

.required {
  color: #dc3545;
}

.form-input, .form-select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 38px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-input:focus, .form-select:focus {
  outline: none;
  border-color: #E4A64E;
  box-shadow: 0 0 0 2px rgba(228, 166, 78, 0.1);
}

/* Estilos para desktop */
@media (min-width: 768px) {
  .form-row {
    flex-wrap: nowrap;
  }
  
  /* Campos que devem ocupar 1/3 da linha */
  .form-group.size-4 {
    flex: 0 0 calc(33.333% - 10px);
  }
  
  /* Campos que devem ocupar 2/3 da linha */
  .form-group.size-8 {
    flex: 0 0 calc(66.666% - 10px);
  }
  
  /* Campos de endereço em 3 colunas */
  .address-row .form-group {
    flex: 0 0 calc(33.333% - 10px);
  }
}

/* Estilo para campos desabilitados */
.disabled-field {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.coupon-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #FF6B00; /* Laranja */
  color: white;
  padding: 15px 30px;
  border-radius: 25px; /* Cantos arredondados */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  text-align: center;
  opacity: 0;
  transition: all 0.3s ease;
  max-width: 80%;
}

.coupon-toast.show {
  opacity: 1;
  animation: slideIn 0.3s ease-out;
}

.coupon-toast.hide {
  opacity: 0;
  animation: slideOut 0.3s ease-in;
}

@keyframes slideIn {
  from {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
  to {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
}

.payment-methods {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.payment-method {
  flex: 1;
  padding: 8px;
  border: 2px solid #ddd;
  border-radius: 30px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.payment-method.active {
  border-color: #E4A64E;
  background-color: #E4A64E;
  color: white;
}

.payment-method:hover {
  border-color: #E4A64E;
}

.coupon-input {
  display: flex;
  gap: 10px;
  align-items: end;
}

.coupon-input .form-group {
  flex: 1;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #E4A64E;
  color: white;
}

.btn-primary:hover {
  background-color: #d6963e;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #5a6268;
}

.btn-outline {
  background-color: transparent;
  border: 1px solid #E4A64E;
  color: #E4A64E;
}

.btn-outline:hover {
  background-color: #E4A64E;
  color: white;
}

.finalize-btn {
  width: 100%;
  padding: 15px;
  font-size: 16px;
  margin-top: 20px;
}

.boleto-display, .pix-display {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-top: 20px;
  text-align: center;
}

.boleto-header {
  border-bottom: 2px solid #333;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.boleto-info {
  text-align: left;
  margin: 20px 0;
}

.boleto-barcode {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  letter-spacing: 1px;
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  margin: 20px 0;
}

.qr-code {
  margin: 20px 0;
}

.pix-code {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  word-break: break-all;
  margin: 20px 0;
}

.copy-btn {
  margin-top: 10px;
}

@media (max-width: 768px) {
  .form-row, .payment-methods {
    flex-direction: column;
  }
  
  .payment-method {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .wizard {
    display: flex;
    flex-wrap: nowrap; /* Impede que os itens quebrem para nova linha */
    overflow-x: auto; /* Permite rolagem horizontal se necessário */
    gap: 5px; /* Espaço entre os steps */
    padding-bottom: 10px; 
  }

  .wizard::before {
    display: none;
  }

  .step {
    flex: 0 0 auto; /* Não permite que os itens cresçam ou encolham */
    width: 30%; /* Largura aproximada para 3 itens */
    min-width: 120px; /* Largura mínima para cada step */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px;
  }

  .step-number {
    width: 30px;
    height: 30px;
    font-size: 14px;
    margin-bottom: 5px;
  }

  .step-info {
    text-align: center;
    padding: 0;

  }

  .step-title {
    font-size: 12px;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  
  .step-description {
    font-size: 10px;
    display: none; 
  }

  .wizard::-webkit-scrollbar {
    display: none;
  }
  
  .wizard {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .plans-container {
    flex-direction: column;
  }

  .plan-card {
    max-width: 100%;
  }

  .whatsapp-chat {
    width: 280px;
    right: 10px;
  }
  
  .whatsapp-button {
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
  }
  
  .whatsapp-button i {
    font-size: 25px;
  }

  .back-button-top {
    position: static;
    text-align: right;
    margin-bottom: 15px;
    padding-right: 15px;
  }

  /* Estilo padrão (mobile-first) - campos em 100% */
.form-group-responsive {
  width: 100%;
}

/* Em desktop - campos com proporções 8 e 4 */
@media (min-width: 768px) {
  .form-group-size-4 {
    flex: 0 0 calc(33.333% - 10px) !important;
    max-width: calc(33.333% - 10px) !important;
  }

  .form-group-size-8 {
    flex: 0 0 calc(66.666% - 10px) !important;
    max-width: calc(66.666% - 10px) !important;
  }
}



}
</style>
